/**
 * Search Drawer — oddit-search-drawer
 * Handles open/close, overlay dismiss, clear button, escape key, and cancel button.
 * Supports Shopify theme editor section lifecycle events.
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-search-drawer';
  var ACTIVE_CLASS = 'oddit-search-drawer--active';

  function initSearchDrawer(container) {
    var section = container || document.querySelector(SECTION_SELECTOR);
    if (!section) return null;

    var overlay = section.querySelector('.oddit-search-drawer__overlay');
    var input = section.querySelector('.oddit-search-drawer__input');
    var clearBtn = section.querySelector('.oddit-search-drawer__clear-btn');
    var cancelBtn = section.querySelector('.oddit-search-drawer__cancel-btn');

    function closeDrawer() {
      section.classList.remove(ACTIVE_CLASS);
      section.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }

    function openDrawer() {
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = scrollbarWidth + 'px';
      section.classList.add(ACTIVE_CLASS);
      section.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (input) {
        input.focus();
      }
    }

    function handleKeydown(e) {
      if (!section.classList.contains(ACTIVE_CLASS)) return;
      if (e.key === 'Escape') {
        closeDrawer();
      } else if (e.key === 'Enter' && input && input.value.trim()) {
        window.location.href = window.theme.routes.searchUrl + '?q=' + encodeURIComponent(input.value.trim());
      }
    }

    // Clear button — clears the input text
    if (clearBtn && input) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        input.focus();
      });
    }

    // Cancel button — closes the drawer
    if (cancelBtn) {
      cancelBtn.addEventListener('click', closeDrawer);
    }

    // Overlay click — closes the drawer (desktop)
    if (overlay) {
      overlay.addEventListener('click', closeDrawer);
    }

    // Escape key — closes the drawer
    document.addEventListener('keydown', handleKeydown);

    // Expose open/close methods globally for external triggers
    window.odditSearchDrawer = {
      open: openDrawer,
      close: closeDrawer
    };

    // Return teardown function for cleanup
    return {
      open: openDrawer,
      close: closeDrawer,
      destroy: function () {
        document.removeEventListener('keydown', handleKeydown);
        if (clearBtn && input) {
          clearBtn.replaceWith(clearBtn.cloneNode(true));
        }
        if (cancelBtn) {
          cancelBtn.replaceWith(cancelBtn.cloneNode(true));
        }
        if (overlay) {
          overlay.replaceWith(overlay.cloneNode(true));
        }
        delete window.odditSearchDrawer;
      }
    };
  }

  // Initial setup
  var instance = initSearchDrawer();

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector(SECTION_SELECTOR)) {
      instance = initSearchDrawer(e.target.querySelector(SECTION_SELECTOR));
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.querySelector(SECTION_SELECTOR) && instance) {
      instance.destroy();
      instance = null;
    }
  });
})();